@if (OverlayPlant()) {
  <nz-modal
    [nzVisible]="OverlayPlant()"
    [nzMask]="false"
    [nzFooter]="null"
    (nzOnCancel)="closed.emit()"
    nzClassName="plant-modal"
    [nzCentered]="true"
    nzWidth="556"
    [nzCloseIcon]="'icons:exit'"
  >
    @if (critical() === 0) {
      <app-card
        [plant]="OverlayPlant()"
        [fine]="true"
        [modal]="true"
        [closeBtn]="false"
        (closeEvent)="closed.emit()"
        (nav)="closed.emit()"
      ></app-card>
    }

    @if (critical() > 0) {
      <app-card
        [plant]="OverlayPlant()"
        [fine]="false"
        [modal]="true"
        [closeBtn]="false"
        (close)="closed.emit()"
        (nav)="closed.emit()"
      >
        @for (building of buildings(); track $index) {
          @if (building.critical_length > 0) {
            <div class="card-layer">
              <h2>{{ building.objectName }}</h2>
              @for (equipment of building.children; track $index) {
                @if (equipment.critical_length > 0) {
                  <span>{{ equipment.objectName }}</span>
                  @for (asset of equipment.critical_children; track $index) {
                    <app-asset-nav-button
                      [asset]="asset"
                      (clickEvent)="closed.emit()"
                      svgIcon="icons:status-exclamation-triangle"
                    >
                      {{ asset.objectName | nameSlice }}
                    </app-asset-nav-button>
                  }
                }
              }
            </div>
          }
        }
      </app-card>
    }
  </nz-modal>
}
